import {useState} from 'react';
import Lottie from 'lottie-react';
import successAnimation from '../../assets/animations/success_screen.json';
import successLoopAnimation from '../../assets/animations/success_screen_loop.json';
import Box from '@mui/material/Box';

const Animation = () => {
  const [animation, setAnimation] = useState<any>(successAnimation);
  const [updateAnimation, setUpdateAnimation] = useState<boolean>(true);
  return (
    <Box sx={{height: '50vh'}}>
      <Lottie
        animationData={animation}
        onLoopComplete={() => {
          if (updateAnimation) {
            setAnimation(successLoopAnimation);
            setUpdateAnimation(false);
          }
        }}
        style={{width: '100%', height: '100%'}}
      />
    </Box>
  );
};

export default Animation;
